/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || | 
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI - v1.1.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2023 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import { Box, Icon, SimpleGrid } from "@chakra-ui/react";
import MiniStatistics from "components/AppCard/Ministatistics";
import IconBox from "components/Icon";
import { AlertCircle, Banknote, Calendar, CreditCard } from 'lucide-react';
import colors from "theme/foundations/colors";

export default function MiniStatsSection(props:any) {
  const {data} = props;
  const {total_tax_payer_amount_due_for_year, total_tax_payer_amount_paid_for_year, next_deadline, is_up_to_date} = data;

  // Fonction pour formater la date d'échéance
  const formatDueDate = (dateString: string | null | undefined): string => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      // Vérifier si la date est valide
      if (isNaN(date.getTime())) return dateString;
      
      // Formater en format français: JJ-MM-AAAA
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      
      return `${day}-${month}-${year}`;
    } catch (error) {
      return dateString;
    }
  };

  // Chakra Color Mode
  return (
    <Box>
      <SimpleGrid
        columns={{ base: 1, md: 4, lg: 4, "2xl": 6 }}
        gap='10px'>
        <MiniStatistics
          endContent={
            <IconBox
              w='46px'
              h='46px'
              borderRadius='20%'
              bg={colors.gray[100]}
              icon={
                <Icon w='25px' h='25px' as={CreditCard} color={'red_origin'} />
              }
            />
          }
          name='Montant total payé'
          value={`${total_tax_payer_amount_paid_for_year} FCFA`}
        />
        <MiniStatistics
        endContent={
            <IconBox
              w='46px'
              h='46px'
              borderRadius='20%'
              bg={colors.gray[100]}
              icon={
                <Icon w='25px' h='25px' as={Banknote} color={'red_origin'} />
              }
            />
          }
          name='Montant dû'
          value={`${total_tax_payer_amount_due_for_year} FCFA`}
        />
        <MiniStatistics
        endContent={
            <IconBox
              w='46px'
              h='46px'
              borderRadius='20%'
              bg={colors.gray[100]}
              icon={<Icon w='25px' h='25px' as={Calendar} color='red_origin' />}
            />
          }
          name="Date d'échéance"
          value={formatDueDate(next_deadline)}
        />
        <MiniStatistics
        endContent={
            <IconBox
              w='46px'
              h='46px'
              borderRadius='20%'
              bg={colors.gray[100]}
              icon={<Icon w='25px' h='25px' as={AlertCircle} color='red_origin' />}
            />
          }
          name='Statut'
          value={is_up_to_date ? "À jour" : "Pas à jour"}
        />
      </SimpleGrid>
    </Box>
  );
}
  